export default {
  CLASSIC: 1,
  STRIP: 2,
  COMPACT: 3,
};



// WEBPACK FOOTER //
// ./src/widget/player-widget/constants/default-settings/channel-layout-values.js